import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

//Images
import error from '../../images/error.png';

class ErrorUnTheam extends Component {

    render() {

        return (
            <React.Fragment>
                <div className="ex-pages">
                    <div className="content-center">
                        <div className="content-desc-center">
                            <Container>
                                <Card className="mo-mt-2">
                                    <CardBody>
                                        <Row className="align-items-center flex-column-reverse">
                                            <Col lg={{ size: 8 }}>
                                                <div className="ex-page-content">
                                                    {/* <h1 className="text-dark">440!</h1> */}
                                                    <h4>Sorry, UnAuthorized Kiosk Theme</h4>
                                                    <p>
                                                        You are Not Authorized to View This Kiosk Theme
                                                    </p>
                                                </div>
                                            </Col>
                                            <Col lg={{ size: 8 }}>
                                                <img src={error} alt="" className="img-fluid mx-auto d-block" />
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Container>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default ErrorUnTheam;